import { useMatches } from 'react-router-dom';

function useBreadcrumbs() {
  const matches = useMatches() as any[];

  return matches
    .filter((m) => m.handle?.crumb)
    .map((m) => {
      const { crumb } = m.handle;
      return typeof crumb === 'function'
        ? crumb(m.data)
        : crumb;
    });
}

export default useBreadcrumbs;
